export type RetainerOption = {
    id: string;
    label: string;
    /** Compact label for the 2-column grid layout. */
    shortLabel: string;
    price: string;
};

export type RetainerOptionId = '1_set' | '2_sets' | '3_sets' | '4_sets';

export const OUTSIDE_ODO_ID = 'outside_odo';

/** Order label persisted on the patient record (and mirrored to Monday) per option id.
 *  Must stay in sync with RETAINER_ORDER_VALUES in the backend retention service. */
export const RETAINER_ORDER_VALUES: Readonly<Record<RetainerOptionId, string>> = {
    '1_set': 'Retainers 1 set upper/lower',
    '2_sets': 'Retainers 2 sets upper/lower',
    '3_sets': 'Retainers 3 sets upper/lower',
    '4_sets': 'Retainers 4 sets upper/lower'
};

/** Persisted order label -> option id, so a stored order can pre-fill the selector. */
export function retainerOptionFromOrderValue(order: string | null): RetainerOptionId | null {
    if (!order) return null;
    const normalized = order.trim().toLowerCase();
    const match = (Object.entries(RETAINER_ORDER_VALUES) as [RetainerOptionId, string][]).find(
        ([, value]) => value.toLowerCase() === normalized
    );
    return match ? match[0] : null;
}

export const RETAINER_OPTIONS: RetainerOption[] = [
    { id: '1_set', label: '1 Set of retainers', shortLabel: '1 Set', price: '$65' },
    { id: '2_sets', label: '2 Sets of retainers', shortLabel: '2 Sets', price: '$125' },
    { id: '3_sets', label: '3 Sets of retainers', shortLabel: '3 Sets', price: '$190' },
    { id: '4_sets', label: '4 Sets of retainers', shortLabel: '4 Sets', price: '$250' },
    {
        id: OUTSIDE_ODO_ID,
        label: 'I will order retainers outside of ODO',
        shortLabel: 'I will order retainers outside of ODO',
        price: ''
    }
];
